export default __webpack_public_path__ + "static/media/governance-hierarchy-mobile.d0f4088a.png";